import { render, staticRenderFns } from "./RegAsDistToExamList.vue?vue&type=template&id=c3e98afc&scoped=true&"
import script from "./RegAsDistToExamList.vue?vue&type=script&lang=js&"
export * from "./RegAsDistToExamList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e98afc",
  null
  
)

export default component.exports